import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { ParticipantExtractQuery } from '../components/reporting/participant-extract-query';
import { Observable } from 'rxjs';
import { param } from 'jquery';
import { CourseExtractQuery } from '../components/reporting/course-extract-query';

@Injectable({
  providedIn: 'root'
})
export class ReportingService {

   apiUrl = environment.apiUrl
  
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
  
    constructor(private http: HttpClient,private _authservice:AuthService) { }

    getParticipantExtract(query:ParticipantExtractQuery):Observable<Blob>
    {
      const token = this._authservice.getAuthToken();
      const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
       
      let params = new HttpParams();
      if (query.StartDate) {
        params = params.append("StartDate", query.StartDate.toISOString());
      }
    
      if (query.EndDate) {
        params = params.append("EndDate", query.EndDate.toISOString());
      }
      params = params.append("ProvinceId",query.ProvinceId);
      params = params.append("ProgramId",query.ProgramId);
      
      return this.http.get(this.apiUrl + "reports/getParticipantExtract", { headers: headers,params:params, responseType:'blob' });

    }

    getCourseExtract(query:CourseExtractQuery):Observable<Blob>
    {
      const token = this._authservice.getAuthToken();
      const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
       
      let params = new HttpParams();
      if (query.StartDate) {
        params = params.append("StartDate", query.StartDate.toISOString());
      }
    
      if (query.EndDate) {
        params = params.append("EndDate", query.EndDate.toISOString());
      }
      params = params.append("ProgramId",query.ProgramId);
      
      return this.http.get(this.apiUrl + "reports/getCourseExtract", { headers: headers,params:params, responseType:'blob' });

    }
}
